// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Settings for generating feedback on a task submission
defined for each task
 */
export interface TaskFeedbackSettingsOutput {
  style: unknown;
}
